export type QtyMode = "quantity" | "amount";
export type TotalMode = "quantity" | "amount";

export enum OrderBookCellType {
  BID = "bid",
  ASK = "ask",
}
